export enum EnrollmentColumns {
  isOptedIn,
  method,
  effectiveFrom,
  effectiveTo,
}
